import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import {
  GET_NOTIFICATIONS_CONFIG,
  SET_NOTIFICATIONS_CONFIG_PAGINATION,
  SET_NOTIFICATIONS_CONFIG_FILTERS,
  RESET_NOTIFICATIONS_CONFIG,
  TOGGLE_NOTIFICATION_CONFIG,
} from 'notifications_config/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const notificationConfig = new schema.Entity('notification_config');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'description'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { notification_config: {} },
  result: { notification_config: [] },
};

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  },
  ...normalize(
    { notification_config: payload.records },
    { notification_config: [notificationConfig] }
  ),
});

export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    notification_config: {
      ...state.entities.notification_config,
      [meta.id]: { ...state.entities.notification_config[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    notification_config: {
      ...state.entities.notification_config,
      [meta.id]: { ...state.entities.notification_config[meta.id], isLoading: false },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    notification_config: {
      ...state.entities.notification_config,
      [payload.notification_config.id]: { ...payload.notification_config, isLoading: false },
    },
  },
});

const reducers = {
  [GET_NOTIFICATIONS_CONFIG]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_NOTIFICATIONS_CONFIG_PAGINATION]: setPagination,
  [SET_NOTIFICATIONS_CONFIG_FILTERS]: setFilters,
  [RESET_NOTIFICATIONS_CONFIG]: reset,
  [TOGGLE_NOTIFICATION_CONFIG]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/reducers/notifications_config_list_reducers.js